import { useState } from "react";
import { faqs } from "@/mocks/home";

function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
            你想了解的都在这
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            关于翻页音效、翻页动画与阅读体验，这里整理了最常被问到的问题。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const open = openIndex === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  open ? "border-primary-200 bg-primary-50/50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="font-medium text-foreground-950">{f.q}</span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all ${
                      open ? "rotate-180 bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;